import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../setup/store/store';
import { AppointmentBooking } from '../models/appointment-booking.model';

const appointmentBookingAdapter = createEntityAdapter({
    // there can only ever be one booking per appointment
    // so for ease, I'm using the appointment id as the key
    selectId: (model: AppointmentBooking) => model.appointmentId,
});

const initialState = appointmentBookingAdapter.getInitialState();

export const appointmentBookingSlice = createSlice({
    initialState,
    name: 'appointmentBookings',
    reducers: {
        appointmentBookingSetOne: appointmentBookingAdapter.setOne,
        appointmentBookingSetMany: appointmentBookingAdapter.setMany,
        appointmentBookingRemoveOne: appointmentBookingAdapter.removeOne,
    },
});

export const appointmentBookingSelectors = appointmentBookingAdapter.getSelectors<RootState>(
    state => state.appointmentBookings,
);
